export const CHECK_DEPOSIT_HISTORY = {
  pageSize: 20,
};
